import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

/**
 * Extract the HTTP status code from an RTK Query error.
 *
 * `FetchBaseQueryError.status` is a number for HTTP responses (e.g. 403) but a
 * string for transport-level failures ('FETCH_ERROR', 'PARSING_ERROR', ...), and
 * `SerializedError` has no `status` at all. Returns the numeric status or undefined.
 */
export function getFetchErrorStatus(error?: FetchBaseQueryError | SerializedError): number | undefined {
  return error && 'status' in error && typeof error.status === 'number' ? error.status : undefined
}
